export default __webpack_public_path__ + "static/media/pesonet.bbdc3b8c.png";